import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

type Setter = (label: string | undefined) => void;

const SetterContext = createContext<Setter>(() => undefined);
const ValueContext = createContext<string | undefined>(undefined);

/** A casca guarda o nome do registro aberto para o breadcrumb (U42). */
export function ScreenCrumbProvider({ children }: { children: ReactNode }) {
  const [label, setLabel] = useState<string | undefined>(undefined);
  return (
    <SetterContext.Provider value={setLabel}>
      <ValueContext.Provider value={label}>{children}</ValueContext.Provider>
    </SetterContext.Provider>
  );
}

/** A tela de um registro informa o nome dele ("ACME Participações") para o último nível da trilha. */
export function useScreenCrumb(label: string | undefined) {
  const set = useContext(SetterContext);
  useEffect(() => {
    set(label);
    return () => set(undefined);
  }, [label, set]);
}

export function useScreenCrumbValue(): string | undefined {
  return useContext(ValueContext);
}
